var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.16,
    height: 88.32,
    viewBox: "0 0 52.16 88.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,88.32A8,8,0,0,1,2.34,74.66l30.51-30.5L2.34,13.66A8,8,0,0,1,13.66,2.34L49.82,38.5a8,8,0,0,1,0,11.32L13.66,86A8,8,0,0,1,8,88.32Z",
    fill: "#D163AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.be413022df621fe4f94e6b98e4dceb46.svg";
export { ForwardRef as ReactComponent };